<div class="input-group">
  <button
    mat-stroked-button
    class="dropdown-toggle"
    type="button"
    id="selectButtonGroup"
    data-bs-toggle="dropdown"
    aria-expanded="false">
    Select vessels
  </button>

  <ul class="dropdown-menu mat-elevation-z4 p-2">
    <li>
      <div class="dropdown-item d-flex align-items-center">
        <mat-checkbox
          [checked]="active"
          (click)="onSelectAll()">
          Select All
        </mat-checkbox>
      </div>
    </li>

    @for (i of locations; track $index; let v = $index) {
      <li>
        <div class="dropdown-item d-flex align-items-center">
          <mat-checkbox
            color="accent"
            [checked]="i.selected"
            (click)="onItemSelectedInternal(i)">
            {{ i.vesselName }}
          </mat-checkbox>
        </div>
      </li>
    }
  </ul>

</div>
